export default {
  id: {
    value: '',
    maxlength: '60',
    required: false,
    state: null,
    defaultValue: ''
  },
  regulationAutoID: {
    value: '',
    maxlength: '60',
    required: true,
    state: null,
    defaultValue: ''
  },
  bodywork: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  repair: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  tapestry: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  painting: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  electrical: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  mechanical: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  third: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  glassware: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withSuppliedParts: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withoutSuppliedParts: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  budgeted: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  franchise: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  carDamage: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  typeConclusionID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null,
    defaultValue: ''
  },
  lossTypeID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null,
    defaultValue: ''
  },
  engineNumber: {
    value: '',
    options: [],
    required: false,
    state: null,
    defaultValue: ''
  },
  reasonFrustration: {
    value: '',
    options: [],
    required: false,
    state: null,
    defaultValue: ''
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true,
    defaultValue: ''
  },
  comments: {
    value: '',
    maxlength: '2000',
    required: false,
    state: null,
    rows: 3
  },
  surveyDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  },
  actionDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/typing/sinistertyping-form.js